import React from 'react'

export default function ProductsInventoryOptionsFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .options-wrapper {
          font-size: 1rem;
          color: whitesmoke;
          background-color: lightgrey;
          display: flex;
          flex-direction: column;
          height: 90%;
          overflow: auto;
        }

        .warehouses-container {
          background-color: rgba(100, 100, 100, 1);
          padding: 5px;
        }

        .classification-container {
          display: flex;
          flex-direction: column;
          background-color: rgba(120, 120, 120, 1);
          padding: 5px;
        }

        .action-button-container {
          display: flex;
          padding: 10px;
          justify-content: flex-end;
        }

        .options-name-wrapper {
          display: flex;
          margin: auto;
          margin-left: 0;
          padding: 5px;
          background-color: transparent;
          border: none;
          width: 100%;
        }
        .options-name-wrapper:hover {
          background-color: darkgrey;
          color: white;
        }
        .options-name-wrapper .option-name {
          flex: 2;
          text-align: left;
        }
        .options-name-wrapper .fai {
          margin: auto;
        }

        #wh-select-all .option-name, #classification-select-all .option-name {
          font-weight: bold;
          text-decoration: underline;
        }

      `}
      </style>
    </React.Fragment>
  )
}
